import { all, takeLatest, put, call } from 'redux-saga/effects';
import { onGetFileContainers } from './api';
import {
  getFileContainers,
  getFileContainersSucceeded,
  getFileContainersFailed,
  getInsuredRiskFileContainers,
  getInsuredRiskFileContainersSucceeded,
  getInsuredRiskFileContainersFailed
} from './slice';

export function* getFileContainersWorker() {
  try {
    const response = yield call(onGetFileContainers);
    yield put(getFileContainersSucceeded(response.data));
  } catch {
    yield put(getFileContainersFailed());
  }
}

export function* getInsuredRiskFileContainersWorker({ payload }) {
  const { insuredRiskId } = payload;
  try {
    const response = yield call(onGetFileContainers, insuredRiskId);
    yield put(getInsuredRiskFileContainersSucceeded(response.data));
  } catch {
    yield put(getInsuredRiskFileContainersFailed());
  }
}

export default function* fileContainersSaga() {
  yield all([
    takeLatest(getFileContainers, getFileContainersWorker),
    takeLatest(getInsuredRiskFileContainers, getInsuredRiskFileContainersWorker)
  ]);
}
